import React, { createContext, useContext, useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getListCarritosPorUserId, purchaseCart, payCartWithKlap } from '@/features/carrito/carritoThunks';

const CartContext = createContext();

export const useCart = () => {
  const context = useContext(CartContext);
  if (!context) {
    throw new Error('useCart must be used within a CartProvider');
  }
  return context;
};

export const CartProvider = ({ children }) => {
  const dispatch = useDispatch();
  const [isCartModalOpen, setIsCartModalOpen] = useState(false);
  const [selectedEventoId, setSelectedEventoId] = useState(null);
  
  // Obtener carritos desde Redux
  const { carritos } = useSelector(state => state.carrito);
  const { isAuthenticated } = useSelector(state => state.auth);

  // Cargar carritos cuando el usuario está autenticado
  useEffect(() => {
    if (isAuthenticated) {
      dispatch(getListCarritosPorUserId());
    }
  }, [isAuthenticated, dispatch]);

  // Reload carts when modal opens
  const openCartModal = (eventoId = null) => {
    if (isAuthenticated) {
      dispatch(getListCarritosPorUserId());
    }
    setSelectedEventoId(eventoId);
    setIsCartModalOpen(true);
  };

  const closeCartModal = () => {
    setIsCartModalOpen(false);
    setSelectedEventoId(null);
  };

  // Get cart for specific event
  const getCartForEvent = (eventoId) => {
    return carritos.find(cart => cart.eventoId === eventoId || cart.eventoUid === eventoId);
  };

  // Get total items across all carts
  const getTotalItems = (uidEvento) => {
    // encontrar el carrito para el evento especificado
    const cart = getCartForEvent(uidEvento);
    if (!cart) return 0;
    return cart.tickets.reduce((total, ticket) => total + ticket.cantidad, 0);
  };

  // Process cart purchase (LEGACY - para pagos sin pasarela)
  const processPurchase = async (carritoUid, success, codigoDescuento = null) => {
    try {
      const result = await dispatch(purchaseCart({ 
        carritoUid, 
        success, 
        codigoDescuento 
      })).unwrap();
      return { success: true, data: result };
    } catch (error) {
      return { success: false, error };
    }
  };

  // Iniciar proceso de pago con KLAP
  // Retorna el klapOrderId para abrir el checkout de KLAP
  const initiateKlapPayment = async (carritoUid, ambassadorReferralCode = null) => {
    console.log("[CartContext] initiateKlapPayment llamado con carritoUid:", carritoUid, "y ambassadorReferralCode:", ambassadorReferralCode);
    try {
      const result = await dispatch(payCartWithKlap({ 
        carritoUid, 
        ambassadorReferralCode 
      })).unwrap();
      // result contiene { klapOrderId: "..." }
      console.log("[CartContext] KLAP Payment initiated, result:", result);
      return { success: true, data: result };
    } catch (error) {
      return { success: false, error };
    }
  };

  const value = {
    carts: carritos,
    isCartModalOpen,
    selectedEventoId,
    getCartForEvent,
    getTotalItems,
    openCartModal,
    closeCartModal,
    processPurchase,
    initiateKlapPayment, // Nueva función para KLAP
    reloadCarts: () => dispatch(getListCarritosPorUserId())
  };

  return (
    <CartContext.Provider value={value}>
      {children}
    </CartContext.Provider>
  );
};